export default "__VITE_ASSET__RCiaj4Yv__"